export default "__VITE_ASSET__BcQVJLvd__"